<template>
  <aside
    class=""
    :style="asideStyle()"
  >
    <q-panel class="clearfix aside-panel">
      <slot />
      <q-menu-bar
        :router="true"
        :menus="defaultMenu"
        :is-collapse="false"
      />
      <q-menu-bar
        :router="true"
        :menus="menus"
        :is-collapse="isCollapse_"
      />
    </q-panel>
  </aside>
</template>

<script>
import config from '../../q-components/q-config'

export default {
  name: 'QAside',
  mixins: [config],
  componentName: 'QAside',

  props: {
    defaultMenuActive: {
      type: String,
      default: '-1'
    },
    isCollapse: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isCollapse_: false,
      menus: [],
      defaultMenu:[
        {
          index: '',
          caption: 'xxx',
          icon: null,
          children:[
            {
              index: '/dashboard/messages/',
              caption: 'child',
              icon: null,
            }
          ]
        }
      ]
    };
  },

  watch: {
    isCollapse() {
      this.isCollapse_ = this.isCollapse;
    },
  },

  mounted() {
    this.$delegate('gausaka', 'fetchMenu', {
      sessionId: this.$store.state.session.sessionId
    }).then((res) => {
      this.menus = res.result.menus;
    }).catch(() => {
    });
  },

  created() {
    this.isCollapse_ = this.isCollapse;

    this.$eventHub.$on("onCollapseAside", () => {
      this.isCollapse_ = !this.isCollapse_;
    })

  },
  methods: {
    asideStyle() {
      const ret = {};
      return ret;
    }
  }
};
</script>
<style scoped>

.aside-panel {
  padding: 5px;
}
</style>
